// HavJoy shape print masks v1
(function () {
'use strict';
if (window.HavjoyDesignPreview) return;
var FRAME_EPSILON_PX = 0.5;
function isObject(v) { return !!v && typeof v === 'object' && !Array.isArray(v); }
  function applyTshirtVariousMockups(template, rawMockups, rawCanvas, contract) {
    contract = contract || {};
    if (contract.preview_mode && ['layer_frame', 'artboard_overlay'].indexOf(contract.preview_mode) === -1) return false;
    if (!template || !Array.isArray(template.mockups) || !Array.isArray(rawMockups) || !isObject(rawCanvas)) return false;
    var expectedKeys = Array.isArray(template.mockupKeys) ? template.mockupKeys : [];
    if (!expectedKeys.length) return false;
    var canvasWidth = Number(rawCanvas.width);
    var canvasHeight = Number(rawCanvas.height);
    if (!Number.isFinite(canvasWidth) || canvasWidth <= 0 || !Number.isFinite(canvasHeight) || canvasHeight <= 0) return false;
    var normalized = {};
    template.mockups.forEach(function (templateMockup) {
      var sourceKey = templateMockup.sourceMockupKey || templateMockup.key;
      var matches = rawMockups.filter(function (raw) { return isObject(raw) && raw.key === sourceKey; });
      if (matches.length !== 1) return;
      var raw = matches[0];
      var templatePrintArea = templateMockup && templateMockup.templatePrintArea;
      if (!templatePrintArea || !templateMockup.templateUrl) return;
      var sourceWidth = Number(raw.width == null ? templateMockup.templateWidth : raw.width);
      var sourceHeight = Number(raw.height == null ? templateMockup.templateHeight : raw.height);
      var renderWidth = Number(raw.render_width == null ? canvasWidth : raw.render_width);
      var renderHeight = Number(raw.render_height == null ? canvasHeight : raw.render_height);
      var runtimeGarmentScale = raw.garment_scale == null ? null : Number(raw.garment_scale);
      var garmentScale = runtimeGarmentScale === null ? templateMockup.templateGarmentScale : runtimeGarmentScale;
      if (
        !Number.isFinite(sourceWidth) || sourceWidth <= 0 || !Number.isFinite(sourceHeight) || sourceHeight <= 0 ||
        Math.abs(sourceWidth - templateMockup.templateWidth) > FRAME_EPSILON_PX ||
        Math.abs(sourceHeight - templateMockup.templateHeight) > FRAME_EPSILON_PX ||
        !Number.isFinite(renderWidth) || renderWidth !== canvasWidth || !Number.isFinite(renderHeight) || renderHeight !== canvasHeight ||
        !Number.isFinite(garmentScale) || garmentScale < 0.5 || garmentScale > 2.5
      ) return;
      var background = templateMockup.variantBackground;
      if (background) {
        sourceWidth = background.width;
        sourceHeight = background.height;
      }
      var containScale = Math.min(renderWidth / sourceWidth, renderHeight / sourceHeight);
      var garmentWidth = sourceWidth * containScale * garmentScale;
      var garmentHeight = sourceHeight * containScale * garmentScale;
      var garmentX = (renderWidth - garmentWidth) / 2;
      var garmentY = (renderHeight - garmentHeight) / 2;
      var area = isObject(raw.print_area) ? raw.print_area : templatePrintArea;
      var clip = isObject(raw.print_area_px) ? raw.print_area_px : {
        x: renderWidth * area.x, y: renderHeight * area.y,
        w: renderWidth * area.w, h: renderHeight * area.h, rotation: area.rotation || 0
      };
      var savedFrame = isObject(raw.frame_px) ? raw.frame_px : null;
      if (contract.preview_mode && !savedFrame) return;
      var frame = savedFrame || clip;
      var frameW = Number(frame.w), frameH = Number(frame.h);
      var centerX = frame.center_x == null ? Number(frame.x) + frameW / 2 : Number(frame.center_x);
      var centerY = frame.center_y == null ? Number(frame.y) + frameH / 2 : Number(frame.center_y);
      var layerRotation = contract.preview_mode === 'layer_frame' && isObject(contract.design_placement)
        ? Number(contract.design_placement.rotation_degrees || 0) : 0;
      var rotation = Number(frame.rotation || 0) + layerRotation;
      if (![centerX, centerY, frameW, frameH, rotation, clip.x, clip.y, clip.w, clip.h, Number(clip.rotation || 0)].every(Number.isFinite) ||
          frameW <= 0 || frameH <= 0 || clip.w <= 0 || clip.h <= 0) return;
      var frameX = centerX - frameW / 2, frameY = centerY - frameH / 2;
      var fit = raw.fit || 'contain';
      if (['contain', 'cover', 'fill'].indexOf(fit) === -1) return;
      normalized[templateMockup.key] = {
        url: background ? background.src : templateMockup.templateUrl,
        width: canvasWidth,
        height: canvasHeight,
        sourceWidth: sourceWidth,
        sourceHeight: sourceHeight,
        renderWidth: renderWidth,
        renderHeight: renderHeight,
        garmentScale: garmentScale,
        garmentRect: { x: garmentX, y: garmentY, w: garmentWidth, h: garmentHeight },
        framePx: { x: frameX, y: frameY, w: frameW, h: frameH, rotation: rotation },
        printArea: { x: clip.x / renderWidth, y: clip.y / renderHeight, w: clip.w / renderWidth, h: clip.h / renderHeight, rotation: Number(clip.rotation || 0) },
        clipPx: { x: clip.x, y: clip.y, w: clip.w, h: clip.h, rotation: Number(clip.rotation || 0) },
        fit: fit,
        previewMode: contract.preview_mode || null,
        renderContractVersion: contract.render_contract_version || null
      };
    });
    if (expectedKeys.some(function (key) { return !normalized[key]; })) return false;
    if (expectedKeys.some(function (key) {
      return !template.mockups.some(function (mockup) { return mockup.key === key; });
    })) return false;
    template.mockups.forEach(function (mockup) {
      if (normalized[mockup.key]) mockup.overlay = normalized[mockup.key];
    });
    return true;
  }

  function setMockupBackgroundGeometry(image, overlay) {
    var rect = overlay.garmentRect;
    image.style.left = (rect.x / overlay.renderWidth * 100) + '%';
    image.style.top = (rect.y / overlay.renderHeight * 100) + '%';
    image.style.width = (rect.w / overlay.renderWidth * 100) + '%';
    image.style.height = (rect.h / overlay.renderHeight * 100) + '%';
    image.style.right = 'auto';
    image.style.bottom = 'auto';
    image.style.transform = 'none';
  }

  function artworkClipPath(overlay) {
    var clip = overlay.clipPx, frame = overlay.framePx;
    if (!clip) return 'none';
    var a = (clip.rotation || 0) * Math.PI / 180;
    var b = -(frame.rotation || 0) * Math.PI / 180;
    var cx = clip.x + clip.w / 2, cy = clip.y + clip.h / 2;
    var fx = frame.x + frame.w / 2, fy = frame.y + frame.h / 2;
    return 'polygon(' + [[-1, -1], [1, -1], [1, 1], [-1, 1]].map(function (corner) {
      var x = corner[0] * clip.w / 2, y = corner[1] * clip.h / 2;
      var dx = cx + x * Math.cos(a) - y * Math.sin(a) - fx;
      var dy = cy + x * Math.sin(a) + y * Math.cos(a) - fy;
      return ((dx * Math.cos(b) - dy * Math.sin(b) + frame.w / 2) / frame.w * 100) + '% ' +
        ((dx * Math.sin(b) + dy * Math.cos(b) + frame.h / 2) / frame.h * 100) + '%';
    }).join(',') + ')';
  }

  function safeUrl(value) {
    if (typeof value !== 'string') return false;
    try { return new URL(value).protocol === 'https:'; } catch (_) { return false; }
  }
  function rect(value) {
    return isObject(value) && ['x','y','w','h'].every(function(k){return Number.isFinite(value[k]);}) && value.w > 0 && value.h > 0 && (value.rotation === undefined || Number.isFinite(value.rotation));
  }
  function validPlacement(p, canvas) {
    return isObject(p) && safeUrl(p.url) && p.sourceWidth > 0 && p.sourceHeight > 0 &&
      p.renderWidth === canvas.width && p.renderHeight === canvas.height &&
      rect(p.garmentRect) && rect(p.framePx) && rect(p.clipPx) && ['contain','cover','fill'].indexOf(p.fit) >= 0 && typeof p.sourceMockupKey === 'string';
  }
  function valid(data) {
    if (!isObject(data) || data.version !== 1 || !isObject(data.render_canvas) ||
        !Number.isFinite(data.render_canvas.width) || data.render_canvas.width <= 0 || !Number.isFinite(data.render_canvas.height) || data.render_canvas.height <= 0 ||
        ['layer_frame','artboard_overlay'].indexOf(data.preview_mode) < 0 || !Number.isInteger(data.render_contract_version) ||
        !isObject(data.placements) || !isObject(data.variants)) return false;
    return Object.keys(data.placements).length > 0 && Object.keys(data.variants).length > 0 &&
      Object.keys(data.placements).every(function(k){return validPlacement(data.placements[k],data.render_canvas);}) &&
      Object.keys(data.variants).every(function(k){return Object.prototype.hasOwnProperty.call(data.placements,data.variants[k]);});
  }
  // Wire v2 stores geometry by garment type and only the selected Shopify image.
  // The renderer continues to consume the expanded v1 shape.
  var typeSnapshots = new WeakMap();
  function garmentType(value) {
    var name=String(value||'').toLowerCase().replace(/[\s_-]/g,'');
    return ['tshirt','hoodie','sweatshirt'].find(function(type){return name.indexOf(type)===0;}) || '';
  }
  function typeWire(data, key) {
    var cached=typeSnapshots.get(data),types=cached || Object.create(null);
    if(!cached)Object.keys(data.placements).forEach(function(k){
      var p=data.placements[k],type=garmentType(p.garmentType || p.sourceMockupKey);
      if(!type)return;
      var scale=p.garmentRect.w/(p.sourceWidth*Math.min(p.renderWidth/p.sourceWidth,p.renderHeight/p.sourceHeight));
      var g={frame:rectArray(p.framePx,true),clip:rectArray(p.clipPx,true),fit:p.fit,scale:rounded(scale,6)};
      if(types[type] && JSON.stringify(types[type])!==JSON.stringify(g))throw new Error('Placement settings differ within '+type+'. Please align the template settings.');
      types[type]=g;
    });
    typeSnapshots.set(data,types);
    var p=data.placements[key],selected=garmentType(p.garmentType || p.sourceMockupKey);
    if(!types[selected])throw new Error('Preview is unavailable for this product type.');
    return {version:2,render_contract_version:data.render_contract_version,preview_mode:data.preview_mode,
      render_canvas:[data.render_canvas.width,data.render_canvas.height],types:types,selected:selected,
      background:[p.url,p.sourceWidth,p.sourceHeight]};
  }
  function expandTypes(wire) {
    if(!isObject(wire.types) || !['tshirt','hoodie','sweatshirt'].includes(wire.selected) ||
      !Array.isArray(wire.render_canvas) || wire.render_canvas.length!==2 ||
      !Array.isArray(wire.background) || wire.background.length!==3 || !safeUrl(wire.background[0]) ||
      !wire.background.slice(1).every(function(n){return Number.isFinite(n)&&n>0;}))return null;
    function decode(a){return Array.isArray(a)&&a.length===5&&a.every(Number.isFinite)?{x:a[0],y:a[1],w:a[2],h:a[3],rotation:a[4]}:null;}
    if(!Object.keys(wire.types).length || !Object.keys(wire.types).every(function(k){var g=wire.types[k];return ['tshirt','hoodie','sweatshirt'].includes(k)&&isObject(g)&&rect(decode(g.frame))&&rect(decode(g.clip))&&['contain','cover','fill'].includes(g.fit)&&Number.isFinite(g.scale)&&g.scale>0;}))return null;
    var g=wire.types[wire.selected];if(!g)return null;
    var w=wire.render_canvas[0],h=wire.render_canvas[1],sw=wire.background[1],sh=wire.background[2],scale=Math.min(w/sw,h/sh)*g.scale;
    var p={url:wire.background[0],sourceWidth:sw,sourceHeight:sh,renderWidth:w,renderHeight:h,
      garmentRect:{x:(w-sw*scale)/2,y:(h-sh*scale)/2,w:sw*scale,h:sh*scale},
      framePx:decode(g.frame),clipPx:decode(g.clip),fit:g.fit,sourceMockupKey:wire.selected};
    return {version:1,render_contract_version:wire.render_contract_version,preview_mode:wire.preview_mode,
      render_canvas:{width:w,height:h},placements:{current:p},variants:{current:'current'},selected:'current',typeWire:wire};
  }
  function rounded(value, digits) {
    var factor = Math.pow(10, digits), result = Math.round(value * factor) / factor;
    return Number.isFinite(result) && (result !== 0 || value === 0) ? result : value;
  }
  function rectArray(r, rotated) {
    var values = [r.x, r.y, r.w, r.h].map(function(v) { return rounded(v, 3); });
    if (rotated) values.push(rounded(r.rotation || 0, 5));
    return values;
  }
  function expand(data) {
    if(isObject(data) && data.version===2 && data.types)return expandTypes(data);
    if (!isObject(data) || data.version !== 2 || !Array.isArray(data.render_canvas) || data.render_canvas.length !== 2 ||
        !Array.isArray(data.geometry) || !data.geometry.length || !Array.isArray(data.placements) || !data.placements.length ||
        !Array.isArray(data.variants) || data.variants.length !== data.placements.length ||
        !Number.isInteger(data.selected) || data.selected < 0 || data.selected >= data.placements.length) return null;
    function toRect(values, rotated) {
      if (!Array.isArray(values) || values.length !== (rotated ? 5 : 4) || !values.every(Number.isFinite)) return null;
      var result = {x:values[0],y:values[1],w:values[2],h:values[3]};
      if (rotated) result.rotation = values[4];
      return rect(result) ? result : null;
    }
    var geometry = data.geometry.map(function(g) {
      if (!Array.isArray(g) || g.length !== 4 || ['contain','cover','fill'].indexOf(g[3]) < 0) return null;
      var garment = toRect(g[0], false), frame = toRect(g[1], true), clip = toRect(g[2], true);
      return garment && frame && clip ? {garmentRect:garment,framePx:frame,clipPx:clip,fit:g[3]} : null;
    });
    if (geometry.some(function(g) { return !g; })) return null;
    var expanded = {version:1,render_contract_version:data.render_contract_version,preview_mode:data.preview_mode,
      render_canvas:{width:data.render_canvas[0],height:data.render_canvas[1]},selected:'p' + data.selected,
      placements:Object.create(null),variants:Object.create(null)};
    for (var i = 0; i < data.placements.length; i++) {
      var p = data.placements[i], ids = data.variants[i];
      if (!Array.isArray(p) || p.length !== 5 || !safeUrl(p[0]) ||
          !Number.isFinite(p[1]) || p[1] <= 0 || !Number.isFinite(p[2]) || p[2] <= 0 ||
          !Number.isInteger(p[3]) || p[3] < 0 || p[3] >= geometry.length || typeof p[4] !== 'string' ||
          !Array.isArray(ids) || !ids.length) return null;
      var key = 'p' + i;
      expanded.placements[key] = Object.assign({url:p[0],sourceWidth:p[1],sourceHeight:p[2],
        renderWidth:data.render_canvas[0],renderHeight:data.render_canvas[1],sourceMockupKey:p[4]},geometry[p[3]]);
      for (var j = 0; j < ids.length; j++) {
        var id = ids[j];
        if (typeof id !== 'string' || !/^\d+$/.test(id) || Object.prototype.hasOwnProperty.call(expanded.variants,id)) return null;
        expanded.variants[id] = key;
      }
    }
    return expanded;
  }
  function parse(text) {
    if (typeof text !== 'string' || text.length > 384000) return null;
    var data;
    try { data=JSON.parse(text); }
    catch (_) {
      // Shopify Liquid can HTML-escape property values before the outer JSON
      // serialization. Decode one entity layer as text, never as executable HTML.
      var entities={quot:'"',amp:'&',apos:"'",lt:'<',gt:'>'};
      text=text.replace(/&(?:quot|amp|apos|lt|gt|#\d+|#x[0-9a-f]+);/gi,function(entity){
        var name=entity.slice(1,-1).toLowerCase();
        if(name[0]!=='#')return entities[name];
        var code=name[1]==='x'?parseInt(name.slice(2),16):parseInt(name.slice(1),10);
        return code>0 && code<=0x10ffff?String.fromCodePoint(code):entity;
      });
      try { data=JSON.parse(text); } catch (_) { return null; }
    }
    if (text.length > 64000) return null;
    if (data && data.version === 2) data = expand(data);
    return text.length <= 64000 && valid(data) && Object.prototype.hasOwnProperty.call(data.placements,data.selected) ? data : null;
  }
  function snapshot(variants, resolve) {
    var data={version:1,placements:Object.create(null),variants:Object.create(null)};
    variants.forEach(function(v){
      var m=resolve(v); if (!m || !m.overlay) return;
      var p=m.overlay;
      if (!data.render_canvas) { data.render_canvas={width:p.renderWidth,height:p.renderHeight}; data.preview_mode=p.previewMode; data.render_contract_version=p.renderContractVersion; }
      var saved={url:p.url,sourceWidth:p.sourceWidth,sourceHeight:p.sourceHeight,renderWidth:p.renderWidth,renderHeight:p.renderHeight,
        garmentRect:p.garmentRect,framePx:p.framePx,clipPx:p.clipPx,fit:p.fit,sourceMockupKey:m.sourceMockupKey || m.key,
        garmentType:m.garment_type || String(m.variantName || m.variant_name || '').split('/')[0]};
      data.placements[m.key]=saved; data.variants[String(v.id)]=m.key;
    });
    // Detach from mutable product/template state at generation completion.
    if (!valid(data)) return null;
    var detached = JSON.parse(JSON.stringify(data));
    // Prepare compact metadata at artwork completion, before Add to Cart.
    if (!ornamentSnapshot(detached)) typeWire(detached,Object.values(detached.variants)[0]);
    return detached;
  }
  function ornamentSnapshot(data) {
    return Object.keys(data.placements).every(function(k) {
      return /^ceramic_(heart|round|star)_white$/.test(data.placements[k].sourceMockupKey);
    });
  }
  function properties(data, artwork, variantId) {
    if (!valid(data) || !safeUrl(artwork)) throw new Error('Design preview data is unavailable.');
    var key=data.variants[String(variantId)];
    if (!key || !Object.prototype.hasOwnProperty.call(data.placements,key)) throw new Error('Preview is unavailable for this variant.');
    var selected=ornamentSnapshot(data) ? Object.assign({},data,{selected:key}) : typeWire(data,key);
    var text=JSON.stringify(selected);
    if (text.length > 64000) throw new Error('Design preview data is too large.');
    return {your_design:artwork,_design_preview:text,_template_mockup_key:data.placements[key].sourceMockupKey};
  }
  function selectProperties(props, variantId, option) {
    var data=parse(props._design_preview);
    if (!data) throw new Error('Design preview data is unavailable.');
    if(data.typeWire){
      option=option||{};
      var type=garmentType(option.productType),img=option.image;
      var src=img&&(img.src||img.url);
      if(typeof src==='string'&&src.indexOf('//')===0)src='https:'+src;
      var wire=Object.assign({},data.typeWire,{selected:type,background:[src,Number(img&&img.width),Number(img&&img.height)]});
      var normalized=expandTypes(wire);
      if(!normalized||!valid(normalized))throw new Error('Preview unavailable for this option. Your original item has been kept.');
      return Object.assign({},props,{_design_preview:JSON.stringify(wire),_template_mockup_key:type});
    }
    var artwork=props.your_design;
    if (props._shape_print_files) {
      var files=JSON.parse(props._shape_print_files);
      var key=data.variants[String(variantId)], placement=data.placements[key];
      artwork=placement && files[placement.sourceMockupKey || key];
      if (!safeUrl(artwork)) throw new Error('Shape print file is unavailable. Your original item has been kept.');
    }
    return Object.assign({},props,properties(data,artwork,variantId));
  }
  var imageCache=new Map();
  function load(url) {
    if (imageCache.has(url)) return imageCache.get(url);
    var task=new Promise(function(resolve,reject){
      var img=new Image(); var timer=setTimeout(function(){imageCache.delete(url);reject(new Error('Preview image timed out'));},30000);
      img.onerror=function(){clearTimeout(timer);imageCache.delete(url);reject(new Error('Preview image unavailable'));};
      img.onload=function(){Promise.resolve(typeof img.decode==='function'?img.decode():null).then(function(){clearTimeout(timer);resolve(img);},img.onerror);};
      img.src=url;
    });
    imageCache.set(url,task);return task;
  }
  function render(root, placement, artwork, changed) {
    if (!root || !placement || !safeUrl(artwork)) return false;
    var key=JSON.stringify([placement,artwork]);
    if(root._hjPreviewRequest && root._hjPreviewRequest.key===key)return true;
    var request={key:key};root._hjPreviewRequest=request;
    root.hidden=false;root.style.cssText+=';position:relative;overflow:hidden;width:100%;aspect-ratio:'+placement.renderWidth+'/'+placement.renderHeight+';background:#fffcf3';
    root.setAttribute('aria-busy','true');delete root.dataset.galleryError;
    root.querySelectorAll('.hj-preview-error').forEach(function(el){el.remove();});
    var backgroundReady=load(placement.url).then(function(image){
      if(root._hjPreviewRequest!==request || request.failed)return;
      var bg=image.cloneNode(false);
      bg.className='hj-v2-preview__mockup';bg.alt='';
      bg.style.cssText='position:absolute;display:block;max-width:none;max-height:none;object-fit:fill';setMockupBackgroundGeometry(bg,placement);
      root.querySelectorAll('img,.hj-preview-retry').forEach(function(el){el.remove();});root.prepend(bg);
      root.removeAttribute('data-preview-empty');
      return bg;
    });
    Promise.all([backgroundReady,load(artwork)]).then(function(images){
      if(root._hjPreviewRequest!==request)return;
      var bg=images[0],art=images[1].cloneNode(false),f=placement.framePx;
      art.className='hj-v2-preview__artwork';art.alt='Your personalized design';
      art.style.cssText='position:absolute;display:block;max-width:none;max-height:none;pointer-events:none;object-position:center;object-fit:'+placement.fit;
      Object.assign(art.style,{left:f.x/placement.renderWidth*100+'%',top:f.y/placement.renderHeight*100+'%',width:f.w/placement.renderWidth*100+'%',height:f.h/placement.renderHeight*100+'%',transformOrigin:'50% 50%',transform:'rotate('+(f.rotation||0)+'deg)',clipPath:artworkClipPath(placement)});
      bg.after(art);
      root.removeAttribute('data-preview-empty');root.removeAttribute('aria-busy');if(changed)changed();
    }).catch(function(){
      if(root._hjPreviewRequest!==request)return;
      request.failed=true;
      root.removeAttribute('aria-busy');root.removeAttribute('data-preview-empty');root.dataset.galleryError='true';
      root.querySelectorAll('img').forEach(function(el){el.remove();});
      var fallback=document.createElement('img');fallback.src=artwork;fallback.alt='Your artwork; mockup preview unavailable';
      fallback.style.cssText='display:block;width:100%;height:100%;object-fit:contain;transform:none';root.prepend(fallback);
      var status=document.createElement('span');status.className='hj-preview-error';status.setAttribute('role','status');
      status.style.cssText='position:absolute;z-index:3;left:8px;right:8px;bottom:8px;font-size:12px;background:#fffcf3;text-align:center';
      status.textContent='Preview unavailable. ';root.appendChild(status);
      var retry=document.createElement('button');retry.type='button';retry.className='hj-preview-retry';retry.textContent='Retry';status.appendChild(retry);
      retry.onclick=function(e){e.preventDefault();e.stopPropagation();root._hjPreviewRequest=null;imageCache.delete(placement.url);imageCache.delete(artwork);render(root,placement,artwork,changed);};if(changed)changed();
    });return true;
  }
  function preloadBackground(url) {
    return safeUrl(url) ? load(url).then(function(){return true;},function(){return false;}) : Promise.resolve(false);
  }
  function hydrate(scope) {
    (scope||document).querySelectorAll('[data-cart-design-preview]').forEach(function(root){
      if(root.closest('[data-hj-deferred-drawer]'))return;
      if(root.dataset.previewHydrated)return;
      var card=root.closest('[data-item-key]');var state;
      try{state=JSON.parse(card.querySelector('[data-cart-line-state]').textContent);}catch(_){return;}
      // Liquid serializes line-item properties as [name, value] pairs;
      // Ajax cart JSON supplies an object. Accept both without losing names.
      var props=state.properties||{};
      if(Array.isArray(props))props=Object.fromEntries(props.filter(function(pair){
        return Array.isArray(pair) && pair.length>=2 && typeof pair[0]==='string';
      }));
      if(!isObject(props))return;
      root.dataset.previewHydrated='true';
      if(!Object.prototype.hasOwnProperty.call(props,'_design_preview'))return;
      var data=parse(props._design_preview),key=data && (data.typeWire?data.selected:data.variants[String(state.variant_id)]);
      if(!data || key!==data.selected || !safeUrl(props.your_design)){
        var msg=document.createElement('span');msg.textContent='Preview unavailable';msg.setAttribute('role','status');root.appendChild(msg);return;
      }
      render(root,data.placements[key],props.your_design);
    });
  }
  window.HavjoyDesignPreview={applyPlacement:applyTshirtVariousMockups,background:setMockupBackgroundGeometry,clipPath:artworkClipPath,snapshot:snapshot,parse:parse,properties:properties,selectProperties:selectProperties,render:render,hydrate:hydrate,preloadBackground:preloadBackground};
  if(typeof document!=='undefined'){
    var scheduled=false;function schedule(){if(scheduled)return;scheduled=true;queueMicrotask(function(){scheduled=false;hydrate(document);});}
    function start(){hydrate(document);new MutationObserver(function(changes){if(changes.some(function(c){return Array.from(c.addedNodes).some(function(n){return n.nodeType===1 && (n.matches('[data-item-key]') || n.querySelector('[data-cart-design-preview]'));});}))schedule();}).observe(document.body,{childList:true,subtree:true});}
    if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start);else start();
  }
})();
